export function signGoogleUserOut() {
  if (!window.google?.accounts?.id) {
    setTimeout(signGoogleUserOut, 200);
    return;
  }

  return window.google.accounts.id.disableAutoSelect();
}
